import { useCallback, useMemo } from "react"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { DomainRoundedIcon } from "@l2r-front/l2r-icons"
import { useImageCollectionDispatchContext } from "@l2r-front/l2r-images"
import { useNetworksContext } from "@l2r-front/l2r-networks"
import { PropTypes } from "@l2r-front/l2r-proptypes"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"

import * as Styled from "./MobileNetworkSelector.styled"

export function MobileNetworkSelector(props) {

    const {
        close,
    } = props

    const [networksState, networksDispatch] = useNetworksContext()
    const { networks, selectedNetwork } = networksState
    const { setImageFeatureClickedPosition } = useImageCollectionDispatchContext()
    const { swapToNetwork } = networksDispatch
    const { t } = useTranslation(I18N_NAMESPACE)

    const changeselectedNetworkSlug = useCallback((newNetworkSlug) => {
        if (newNetworkSlug !== selectedNetwork.slug) {
            swapToNetwork(newNetworkSlug)
            setImageFeatureClickedPosition()
        }

        close()
    }, [selectedNetwork, setImageFeatureClickedPosition, swapToNetwork, close])

    const networksList = useMemo(() => {
        if (!networks) {
            return null
        }

        return networks.map(network => {
            return ({
                id: network.slug,
                label: network.name,
                value: network.slug,
                icon: (props) => <DomainRoundedIcon {...props} />,
            })

        })
    }, [networks])

    if (!networksList) {
        return <Styled.Text variant="Regular">
            {t(I18N_NAMESPACE, "containers.networkSelector.noNetwork")}
        </Styled.Text>
    }

    return (
        <Styled.RadioButtonList
            itemsList={networksList}
            onChange={changeselectedNetworkSlug}
            selectedValue={selectedNetwork?.slug}
        />
    )
}

MobileNetworkSelector.propTypes = {
    close: PropTypes.func.isRequired,
}
